export const SCHEDULED_CALL_TIME_SET_DURATION = 30
export const SCHEDULED_CALL_TIME_NOT_SET_DURATION = 1440
